import { LockedAccountEnum } from '@/enums/powerMarkets/LockedAccountEnum.ts';
import { TimeFormatEnum } from '@/enums/powerMarkets/TimeFormatEnum.ts';
import { ISiteSettings } from '@/interfaces/powerMarkets/settings/ISiteSettings.ts';
import { DEFAULT_BID_COLOUR, DEFAULT_OFFER_COLOUR } from '@/utils/balancing/boaHelper.ts';

export const DEFAULT_SITE_SETTINGS: ISiteSettings = {
    country: 'None',
    fallbackCountry: 'Gb',
    bidColour: DEFAULT_BID_COLOUR,
    offerColour: DEFAULT_OFFER_COLOUR,
    bingoColourOverrides: {},
    bingoStringOverrides: {},
    useTradingPeriod: false, // LEGACY ITEM, DO NOT DIRECTLY REFERENCE, USE GETTER 'boaWindowType' INSTEAD
    boaWindowType: {
        all: 'current',
    }, // DO NOT DIRECTLY REFERENCE, USE GETTER 'boaWindowType' INSTEAD
    autoRollover: true,
    showTimer: false,
    filterAcceptedUnwinds: false,
    filterUnacceptedUnwinds: false,
    filterTrackedPlants: false,
    orderAcceptedFirst: false,
    plantDisplayOption: 'id',
    userId: '',
    userEmail: '',
    sideNavVisible: true,
    chartHoverChoice: true,
    stepChartOption: false,
    fullChartFunctionality: false,
    fullDAChartAxes: false,
    forecastHistorySeriesToShow: null,
    melBelowPnToleranceToUse: null,
    excelAsCsv: false,
    lockedAccount: LockedAccountEnum.Unlocked,
    tabUpdateValue: 'none',
    timeFormatValue: TimeFormatEnum.TwentyFourHour,
    tableUnitValue: 'hover',
    terms: {
        agreed: false,
        date: null,
    },
    chosenPlantGroupName: null,
    chosenPlantsByGroup: {},
    // TEMP dual-site: legacy mirrors dual-written only via plantGroupLegacySettings on plant-group saves.
    // chosenPlants: [],
    // chosenPlantGroupColour: 'rgb(0, 163, 199)',
    // plantGroupColourOverride: false,
    globalBingoChoices: {},
    globalBingoSoundChoices: {},
    plantSelection: 'default',
    plantActivityDisplayOption: 'Default',
    showGeneration: false,
    reversePlantActivityOrder: false,
    reverseNivSign: false,
    reverseNivForecastSign: false,
    nivInMwh: false,
    versionNumber: 0.3,
    minutesDelayToReport: 4,
    showZoneInPlantNameBingo: true,
    defaultPlantGroupColour: 'rgb(0, 163, 199)',
    plantGroupColourOverrideByGroup: {},
    // leaderboardCapacityInMwh: false, TODO: Check with Shiv - is it correct that this is unused in the old code?
    showNearestPointOnTooltip: false,
    defaultBoaTab: 'Overview',
    useColouredFlagsForFlaggedBoaActions: true,
    liveTableTimezoneOverrides: {},
    boaAcceptedTableSortOptions: {},
};
